import React, { useState } from 'react';
import {
  Navigate, RouterProvider, createBrowserRouter, useLocation,
} from 'react-router-dom';
import PublicHomePage from '../../routes/public-home-page/PublicHomePage';
import { WebsiteShutdownNoticeProvider } from './WebsiteShutdownNotice';

// Set in location state when a visitor arrives from any url other than the home page
// (deep link, shared post/profile link, bookmarked /app page, etc.)
const REDIRECTED_FROM_BLOCKED_URL = 'redirectedFromBlockedUrl';

function ShutdownHomePage() {
  const location = useLocation();
  const state = location.state as Record<string, unknown> | null;
  const redirectedFromBlockedUrl = state?.[REDIRECTED_FROM_BLOCKED_URL] === true;

  return (
    <WebsiteShutdownNoticeProvider initiallyOpen={redirectedFromBlockedUrl}>
      <PublicHomePage />
    </WebsiteShutdownNoticeProvider>
  );
}

/**
 * Replaces the whole app while website access is revoked. Only the static public home page is
 * available, and every other url is redirected to it, so no authenticated or api-backed page
 * can ever be mounted.
 */
function WebsiteShutdownApp() {
  const [router] = useState(() => createBrowserRouter([
    { path: '/', element: <ShutdownHomePage /> },
    {
      path: '*',
      element: <Navigate to="/" replace state={{ [REDIRECTED_FROM_BLOCKED_URL]: true }} />,
    },
  ]));

  return <RouterProvider router={router} />;
}

export default WebsiteShutdownApp;
